<template>
  <div
    v-if="linkedBlock"
    class="desktop-mega-menu"
    :class="linkedBlock.type"
  >
    <template v-if="linkedBlock.type === 'style_1'">
      <!-- LARGE 2 TEXT, 3 IMAGES -->
      <div
        class="desktop-mega-menu__wrapper"
        :class="linkedBlock.type"
      >
        <div class="desktop-mega-menu__left">
          <!-- First 2 links -->
          <mega-menu-list
            :sublinks="link.sublinks"
            :max-length="2"
          />
        </div>
        <div class="desktop-mega-menu__right">
          <div class="desktop-mega-menu__images">
            <mega-menu-image
              v-for="index in 3"
              :key="index"
              :banner-image="linkedBlock[`banner_image_${index}`]"
              :banner-link="linkedBlock[`link_banner_image_${index}`]"
              :banner-overlay-opacity="
                linkedBlock[`overlay_banner_image_${index}`]
              "
              :banner-title="linkedBlock[`title_banner_image_${index}`]"
              :class="linkedBlock[`title_banner_position_${index}`]"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="linkedBlock.type === 'style_2'">
      <!-- SMALL 1 TEXT, 1 IMAGE -->
      <div
        class="desktop-mega-menu__wrapper"
        :class="linkedBlock.type"
      >
        <div class="desktop-mega-menu__left">
          <!-- First 1 link -->
          <mega-menu-list
            :sublinks="link.sublinks"
            :max-length="1"
          />
        </div>
        <div class="desktop-mega-menu__right">
          <div class="desktop-mega-menu__images">
            <mega-menu-image
              :banner-image="linkedBlock[`banner_image_1`]"
              :banner-link="linkedBlock[`link_banner_image_1`]"
              :banner-overlay-opacity="linkedBlock[`overlay_banner_image_1`]"
              :banner-title="linkedBlock[`title_banner_image_1`]"
              :class="linkedBlock[`title_banner_position_1`]"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="linkedBlock.type === 'style_3'">
      <!-- SMALL 1 TEXT -->
      <div
        class="desktop-mega-menu__wrapper"
        :class="linkedBlock.type"
      >
        <div class="desktop-mega-menu__left">
          <!-- First 1 link -->
          <mega-menu-list
            :sublinks="link.sublinks"
            :max-length="1"
          />
        </div>
      </div>
    </template>

    <template v-if="linkedBlock.type === 'style_4'">
      <!-- LARGE 5 IMAGE/CONTENT -->
      <div
        class="desktop-mega-menu__wrapper"
        :class="linkedBlock.type"
      >
        <div class="desktop-mega-menu__images">
          <mega-menu-image
            v-for="index in 5"
            :key="index"
            :banner-image="linkedBlock[`banner_image_${index}`]"
            :banner-link="linkedBlock[`link_banner_image_${index}`]"
            :banner-overlay-opacity="
              linkedBlock[`overlay_banner_image_${index}`]
            "
            :banner-title="linkedBlock[`title_banner_image_${index}`]"
            :class="linkedBlock[`title_banner_position_${index}`]"
          />
        </div>
      </div>
    </template>

    <template v-if="linkedBlock.type === 'style_5'">
      <!-- LARGE 2 TEXT, 2 IMAGES -->
      <div
        class="desktop-mega-menu__wrapper"
        :class="linkedBlock.type"
      >
        <div class="desktop-mega-menu__left">
          <!-- First 2 links -->
          <mega-menu-list
            :sublinks="link.sublinks"
            :max-length="2"
          />
        </div>
        <div class="desktop-mega-menu__right">
          <div class="desktop-mega-menu__images">
            <mega-menu-image
              v-for="index in 2"
              :key="index"
              :banner-image="linkedBlock[`banner_image_${index}`]"
              :banner-link="linkedBlock[`link_banner_image_${index}`]"
              :banner-overlay-opacity="
                linkedBlock[`overlay_banner_image_${index}`]
              "
              :banner-title="linkedBlock[`title_banner_image_${index}`]"
              :class="linkedBlock[`title_banner_position_${index}`]"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="linkedBlock.type === 'style_6'">
      <!-- LARGE 3 TEXT, 1 IMAGES (1 LARGE TEXT) -->
      <div
        class="desktop-mega-menu__wrapper"
        :class="linkedBlock.type"
      >
        <div class="desktop-mega-menu__left">
          <!-- First 3 links -->
          <mega-menu-list
            :sublinks="link.sublinks"
            :max-length="3"
          />
        </div>
        <div class="desktop-mega-menu__right">
          <div class="desktop-mega-menu__images">
            <mega-menu-image
              :banner-image="linkedBlock[`banner_image_1`]"
              :banner-link="linkedBlock[`link_banner_image_1`]"
              :banner-overlay-opacity="linkedBlock[`overlay_banner_image_1`]"
              :banner-title="linkedBlock[`title_banner_image_1`]"
              :class="linkedBlock[`title_banner_position_1`]"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-if="linkedBlock.type === 'style_7'">
      <!-- LARGE 4 TEXT, 1 IMAGES (1 LARGE TEXT) -->
      <div
        class="desktop-mega-menu__wrapper"
        :class="linkedBlock.type"
      >
        <div class="desktop-mega-menu__left">
          <!-- First 4 links -->
          <mega-menu-list
            :sublinks="link.sublinks"
            :max-length="4"
          />
        </div>
        <div class="desktop-mega-menu__right">
          <div class="desktop-mega-menu__images">
            <mega-menu-image
              :banner-image="linkedBlock[`banner_image_1`]"
              :banner-link="linkedBlock[`link_banner_image_1`]"
              :banner-overlay-opacity="linkedBlock[`overlay_banner_image_1`]"
              :banner-title="linkedBlock[`title_banner_image_1`]"
              :class="linkedBlock[`title_banner_position_1`]"
            />
          </div>
        </div>
      </div>
    </template>

    <div
      v-if="linkedBlock.block_link_label_1 && linkedBlock.block_link_1"
      class="desktop-mega-menu__link text-center"
    >
      <a
        :href="linkedBlock.block_link_1"
        class="link link--underline"
        v-text="linkedBlock.block_link_label_1"
      />
    </div>
  </div>
</template>

<script>

/**
 * Component: Mega Menu
 * -----------------------------------------------------------------------------
 * @param {Object}  [link] - Formatted parent link object.
 * @param {Array}   [sectionBlocks] - Formatted section blocks array.
 */
import MegaMenuImage from './mega-menu-image'
import MegaMenuList from './mega-menu-list'

export default {
  name: 'MegaMenu',

  components: {
    MegaMenuImage,
    MegaMenuList,
  },

  props: {
    link: {
      type: Object,
      default: null,
    },
    linkedBlock: {
      type: [Boolean, Object],
      default: false,
    },
  },
}
</script>

<style src="./mega-menu.scss" lang="scss"></style>
